<template>
  <v-layout>

    <v-flex>
      <v-row align="center" no-gutters class="">
        <v-col class="text-left ml-n6 mt-n4">
          <v-breadcrumbs :items="subNavs"></v-breadcrumbs>
        </v-col>
      </v-row>

      <v-card class="pa-6 mt-3">
        <v-card-title>
          Client
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text class="text--primary mt-6">
          <v-row no-gutters>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>
                          mdi-account-outline
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{user.name}}</v-list-item-title>
                        <v-list-item-subtitle>Name</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>
                          mdi-email-outline
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{user.email}}</v-list-item-title>
                        <v-list-item-subtitle>Email</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>
                          mdi-phone-classic
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{user.contact_no}}</v-list-item-title>
                        <v-list-item-subtitle>Contact No.</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title><span class="text-subtitle-1 font-weight-bold">{{formatNumberAmount($numeral, user.total_points)}}</span></v-list-item-title>
                        <v-list-item-subtitle>Accumulated Points</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title><span class="text-subtitle-1 font-weight-bold">{{formatNumberAmount($numeral, Math.floor((user.total_points - user.used_points) * 100)/100)}}</span></v-list-item-title>
                        <v-list-item-subtitle>Remaining Points</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12">
                  <v-list two-line>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title><span class="text-subtitle-1 font-weight-bold">{{formatNumberAmount($numeral, user.used_points)}}</span></v-list-item-title>
                        <v-list-item-subtitle>Used Points</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-title>
          Transactions
          <v-spacer></v-spacer>
          <v-select
            v-model="status"
            :items="reward_statuses"
            @change="filterBy"
            menu-props="auto"
            label="Status"
            item-text="name"
            class="max-width-300 mr-10"
            prepend-icon="mdi-filter-outline"
            item-value="id"
            hide-details
          >
          </v-select>
          <v-text-field
            v-model="search"
            class="table-search"
            append-icon="mdi-magnify"
            label="Search"
            hide-details>
          </v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="rewards"
          :server-items-length="pagination.total"
          :items-per-page="pagination.per_page"
          :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
          :loading="loading"
          loading-text="Loading Invoices..."
          item-key="id"
          no-data-text="No Rewards Found"
          :options.sync="options"
          :item-class="itemRowBackground"
          ref="table">

          <template v-slot:[`item.created_at`]="{ item }">
            {{ item.created_at | moment("MMM D, YYYY h:mmA") }}
          </template>



          <template v-slot:[`item.amount`]="{ item }">
            {{ formatNumberAmount($numeral, item.amount) }}
          </template>

          <template v-slot:[`item.points`]="{ item }">
            {{ formatNumberAmount($numeral, item.points) }}
          </template>

          <template v-slot:[`item.trans_type`]="{ item }">
            {{ getTransTypeName(item.trans_type) }}
          </template>

          <template v-slot:[`item.deposit_slip`]="{ item }">
            {{ getTransTypeName(item.trans_type) }}
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <RewardStatus :status="item.status" :small="true" :statuses="reward_statuses"></RewardStatus>
          </template>

          <template v-slot:[`item.deposit_slip`]="{ item }">
            <v-img
              v-if="item.deposit_slip"
              @click="showImg(item.deposit_slip)"
              :src="item.deposit_slip"
              :lazy-src="item.deposit_slip"
              aspect-ratio="1"
              width="50px"
              class="grey lighten-2 mx-auto"
            ></v-img>
          </template>


        </v-data-table>

      </v-card>
      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
    </v-flex>
  </v-layout>
</template>

<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import { mapGetters } from "vuex";
  import RewardStatus from '@/components/RewardStatus.vue'

  export default {
    name: 'AgentRewardsPage',
    data: () => ({
      agentNamespace: 'sales-agent',
      slug: '',
      loading: false,
      subNavs: [
        {
          text: 'Rewards Club Royale',
          disabled: false,
          exact: true,
          to: {
            name: 'rewards-clients'
          },
        },
        {
          text: 'Client',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      search: '',
      awaitingSearch: false,
      status: '',
      statuses: [],
      reward_transaction_types: [],
      reward_statuses: [],
      pagination: {
        page: 1,
        per_page: 1,
        total: 0,
        next: 0
      },
      options: {},
      headers: [
        {
          text: 'Transaction Code',
          align: 'start',
          value: 'trans_no',
          sortable: false,
          width: 160
        },
        {
          text: 'Amount',
          align: 'right',
          value: 'amount',
          sortable: false
        },
        {
          text: 'Points',
          align: 'right',
          value: 'points',
          sortable: false
        },
        {
          text: 'Transaction Type',
          align: 'center',
          value: 'trans_type',
          sortable: false,
        },
        {
          text: 'Transaction Date',
          align: 'center',
          value: 'created_at',
          sortable: false,
        },
        {
          text: 'Proof of Payment',
          align: 'center',
          value: 'deposit_slip',
          sortable: false
        },
        {
          text: 'Reference No.',
          align: 'center',
          value: 'ref_no',
          sortable: false
        },
        {
          text: 'Status',
          align: 'center',
          value: 'status',
          sortable: false
        }
      ],
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      warehouses: [],
      locations: [],
      addRewardDialog: {
        show: false,
        selected_items: [],
        client_id: ''
      },
      rewards: [],
      dialog: {
        show: false,
        title: 'Delete Item',
        body: 'Are you sure you want to delete this item?',
        type: '',
        item: {},
        confirmBtn: 'Yes',
        cancelBtn: 'Cancel'
      },
      user: {
        email: '',
        first_name: '',
        last_name: '',
        contact_no: '',
        warehouse_id: '',
        location_id: '',
        address: ''
      }
    }),
    computed: {
      ...mapGetters(['formatNumberAmount', 'formatNumber', 'formatNumberAmountNoComma']),
    },
    watch: {
      options: {
        handler () {
          this.getClientRewards()
        },
        deep: true,
      },
      search: function (val) {
        if (!this.awaitingSearch) {
          setTimeout(() => {
            this.options.page = 1
            this.getClientRewards()
            this.awaitingSearch = false;
          }, 1000); // 1 sec delay
        }
        this.awaitingSearch = true;
      },
    },
    methods: {
      showImg (imgLoc) {
        window.open(imgLoc, '_newtab');
      },
      doCancel () {
        this.dialog.show = false
      },
      getTransTypeName: function(id){
        let reward_trans_types = this.reward_transaction_types.filter(status => {
          return status.id == id
        })

        if(reward_trans_types.length > 0){
          return reward_trans_types[0].name
        }
      },
      filterBy (id) {
        this.status = id
        this.options.page = 1
        this.getClientRewards()
      },
      itemRowBackground: function (item) {
         return (item.status == this.$getConstRewardStatus('REWARD_FOR_CONFIRMATION')) ? 'red lighten-4' : ''
      },

      getDefaultData () {
        let self = this
        this.$http.plain.get(this.agentNamespace+'/default-data?reward_statuses=true&reward_transaction_types=true')
          .then(response => {
            this.reward_transaction_types = response.data.reward_transaction_types
            this.reward_statuses = response.data.reward_statuses
          })
          .catch(error => {
            console.log(error);
          })
      },
      getClient () {
        let self = this
        this.$http.plain.get(this.agentNamespace+'/clients/'+this.slug)
          .then(response => {
            this.user = response.data
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
          })
      },
      getClientRewards () {
        if (this.loading) {
          return false
        }

        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        let sorting = []
        let params = []

        if (sortBy.length === 1 && sortDesc.length === 1) {
          sortBy.forEach(function (item, index) {
            let sort = 'ASC'
            if (!sortDesc[index]) {
              sort = 'DESC'
            }
            sorting.push(item+'='+sort)
          });
        }

        if (this.search.length > 0){
          params.push('&search='+this.search)
        }
        if (this.status.length > 0){
          params.push('&status='+this.status)
        }



        this.loading = true
        let self = this
        this.$http.plain.get(this.agentNamespace+'/rewards?client_id='+this.slug+'&page='+ page + '&per_page=' + itemsPerPage + params.join())
          .then(response => {
            this.rewards = response.data.rewards
            if (response.data.pagination) {
              let pagination = response.data.pagination

              this.pagination.total = pagination.count
            }
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      }
    },
    mounted() {
      this.slug = this.$route.params.slug
      this.getClientRewards()
      this.getDefaultData()
      this.getClient()
    },
    components: {
      SnackBar,
      RewardStatus
    }
  }
</script>
